// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Avcx","left":"styles_left__1GjDy","desktopActions":"styles_desktopActions__2Zkrs","title":"styles_title__1kIaL"};